import React, { useState } from 'react';
import { inject } from 'mobx-react';
import { useClassName } from 'common/hooks';
import { SVGIcon } from 'common/components';
import './resend-order-confirmation.less';
import { Loader } from 'common/lazy';

const ResendOrderConfirmation = ({
  orders,
  bookingReference,
  className: extraClassName,
}) => {
  const className = useClassName('ResendOrderConfirmation');
  const [loading, setLoading] = useState(false);

  const handleResendEmail = async () => {
    try {
      setLoading(true);
      await orders.resendConfirmationEmail(bookingReference);
    } catch (e) {
      console.error(`Error re-sending confirmation email, error: ${e.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className={[className('container'), extraClassName]
        .filter(Boolean)
        .join(' ')}
      onClick={() => {
        if (loading) return;
        handleResendEmail();
      }}>
      {loading ? (
        <Loader size="tiny" active inline />
      ) : (
        <SVGIcon name="email" size="tiny" />
      )}
      Resend
    </div>
  );
};

export default inject('orders')(ResendOrderConfirmation);
